<div class="toolbar-container pb-3">
  <div class="rental-title">
    <ng-container *ngIf="rental">
      <app-rental-image [rental]="rental" [size]="40"></app-rental-image>
      {{ rental.name }}
    </ng-container>
    <app-page-help videoId="Dp5Nrbv36zY" class="ml-2"></app-page-help>
  </div>

  <div>
    <button
      *ngIf="rentalConnection$ | asyncSchedule | async; let connection"
      (click)="onAirbnbPricingPreferences(connection)"
      [disabled]="(isSaving$ | async) === 'save'"
      type="button"
      class="btn btn-cst-info text-uppercase"
      tabindex="53"
    >
      <i class="fab fa-airbnb"></i> Price Settings
    </button>

    <button
      (click)="clear()"
      [disabled]="(isSaving$ | async) === 'clear' || !isClearable || (1 | isReadonlyRole)"
      type="button"
      class="btn btn-danger text-uppercase create-btn"
      tabindex="52"
    >
      <i class="fal {{ (isSaving$ | async) === 'clear' ? 'fa-spinner fa-spin' : 'fa-trash-alt' }}"></i>
      Clear
    </button>

    <button
      (click)="onSubmit(form)"
      [disabled]="(isSaving$ | async) === 'save' || (1 | isReadonlyRole)"
      type="button"
      class="btn btn-success text-uppercase create-btn"
      tabindex="51"
    >
      <i class="fal {{ (isSaving$ | async) === 'save' ? 'fa-spinner fa-spin' : 'fa-save' }}"></i>
      Save
    </button>
  </div>
</div>

<div class="form-container">
  <form [formGroup]="form" (submit)="onSubmit(form)" [formEditablePermission]="form">
    <h5>RENTAL BASE RATE DETAILS</h5>

    <div class="row">
      <div
        class="col-sm-6"
        [matTooltip]="(isRategenieSync$ | async) ? 'These can be changed only in Rategenie.' : ''"
        matTooltipClass="text-center"
        matTooltipPosition="above"
      >
        <mat-form-field class="mat-block">
          <input
            type="number"
            min="0"
            matInput
            placeholder="Nightly ({{ currencySymbol }})"
            formControlName="nightly"
            tabindex="11"
            (change)="roundDecimal('nightly')"
          />
        </mat-form-field>
      </div>

      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            type="number"
            min="0"
            matInput
            placeholder="Weekend Night ({{ currencySymbol }})"
            formControlName="weekend"
            tabindex="12"
            (change)="roundDecimal('weekend')"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matTooltip="The weekly value entered here will apply only to bookings created manually in Tokeet, or on a Tokeet Website or Booking Engine."
            matTooltipClass="text-center"
            matTooltipPosition="above"
            type="number"
            min="0"
            matInput
            placeholder="Weekly ({{ currencySymbol }})"
            formControlName="weekly"
            tabindex="13"
            (change)="roundDecimal('weekly')"
          />
        </mat-form-field>
      </div>

      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matTooltip="The monthly value entered here will apply only to bookings created manually in Tokeet, or on a Tokeet Website or Booking Engine."
            matTooltipClass="text-center"
            matTooltipPosition="above"
            type="number"
            min="0"
            matInput
            placeholder="Monthly ({{ currencySymbol }})"
            formControlName="monthly"
            tabindex="14"
            (change)="roundDecimal('monthly')"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <mat-form-field
          class="mat-block"
          [matTooltip]="(isRategenieSync$ | async) ? 'These can be changed only in Rategenie.' : ''"
          matTooltipClass="text-center"
          matTooltipPosition="above"
        >
          <input
            required
            type="number"
            min="1"
            step="1"
            matInput
            placeholder="Minimum Stay (nights)"
            formControlName="minimum"
            tabindex="2"
            (change)="roundInteger('minimum')"
          />
          <mat-error *ngIf="form.get('minimum').touched && form.get('minimum').hasError('required')">
            Minimum Stay is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="form.get('minimum').touched && form.get('minimum').hasError('min')">
            Value must be <strong>at least 1</strong>
          </mat-error>
          <mat-error *ngIf="form.get('minimum').touched && form.get('minimum').hasError('digits')">
            Value is invalid
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-6">
        <mat-form-field
          class="mat-block"
          [matTooltip]="(isRategenieSync$ | async) ? 'These can be changed only in Rategenie.' : ''"
          matTooltipClass="text-center"
          matTooltipPosition="above"
        >
          <input
            type="number"
            min="0"
            step="1"
            matInput
            placeholder="Maximum Stay (nights)"
            formControlName="maximum"
            tabindex="3"
            (change)="roundInteger('maximum')"
          />
          <mat-error *ngIf="form.get('maximum').touched && form.get('maximum').hasError('digits')">
            Value is invalid
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <h5>ADDITIONAL GUEST FEE</h5>

    <div class="row">
      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <input
            type="number"
            matInput
            placeholder="({{ currencySymbol }})"
            formControlName="additionalFeeAmount"
            min="0"
            tabindex="21"
            (change)="roundDecimal('additionalFeeAmount')"
          />
          <mat-hint>per person, per night</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <input
            type="number"
            matInput
            placeholder="Guest Count"
            formControlName="additionalFeeThreshold"
            min="0"
            step="1"
            tabindex="22"
            (change)="roundInteger('additionalFeeThreshold')"
          />
          <mat-hint>above this many guests</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-checkbox formControlName="ignoreBDC" class="field-ignore-bdc"> Ignore for booking.com </mat-checkbox>
      </div>
    </div>
  </form>
</div>
